import React, { FC } from 'react';
import { ArrowForwardIcon, Asset } from '@clearcover/atlas';
import {
  capitalizeFirstLetter,
  getOrdinalSuffix,
  transformEnum,
} from 'Policies/utils/helpers/helpers';

import styles from './styles.module.css';

type FrequencyData = {
  installmentInterval: string;
  daysOfWeek?: string[];
  daysOfMonth?: number[];
};

type PaymentFrequencyChangeProps = {
  currentFrequency: FrequencyData;
  newFrequency: FrequencyData;
  isLoading?: boolean;
};

export const PaymentFrequencyChange: FC<PaymentFrequencyChangeProps> = ({
  currentFrequency,
  newFrequency,
  isLoading = false,
}) => {
  const formatFrequency = (frequency: FrequencyData) => {
    const { installmentInterval, daysOfWeek, daysOfMonth } = frequency;

    return (
      <span>
        <span>{capitalizeFirstLetter(transformEnum(installmentInterval))}</span>
        {['WEEKLY', 'BI_WEEKLY'].includes(installmentInterval) &&
          daysOfWeek &&
          daysOfWeek.length > 0 && (
            <span>
              :{' '}
              {capitalizeFirstLetter(
                transformEnum(daysOfWeek[0].toLowerCase())
              )}
            </span>
          )}
        {['MONTHLY', 'SEMI_MONTHLY'].includes(installmentInterval) &&
          daysOfMonth &&
          daysOfMonth.length > 0 && (
            <span>
              : {daysOfMonth.map(day => getOrdinalSuffix(day)).join(', ')}
            </span>
          )}
      </span>
    );
  };

  return (
    <div className={styles.changeMessage}>
      <span className={styles.changeLabel}>Payment frequency change: </span>
      {isLoading ? (
        <div className={styles.loadingPlaceholder}></div>
      ) : (
        <>
          <span className={styles.changeDetails}>
            {formatFrequency(currentFrequency)}
          </span>
          <span className={styles.arrowForwardIcon}>
            <Asset
              icon={ArrowForwardIcon}
              height={16}
              width={16}
              description="Arrow Forward icon"
            />
          </span>
          <span className={styles.changeDetails}>
            {formatFrequency(newFrequency)}
          </span>
        </>
      )}
    </div>
  );
};
